import React from 'react'

type Props = {
    title?: string
}

export default function Demo({title}: Props) {
  return (
    <div>Demo</div>
  )
}